import { Alert } from '@design-system';

const Placeholder = ({ componentName }: { componentName: string }) => (
  <Alert status="error">
    The component <strong>{componentName}</strong> has not been created yet.
  </Alert>
);

export default Placeholder;
